const gaId = process.env.VUE_APP_GAID
const gaId2 = process.env.VUE_APP_GAID2
export default {
    addScript() {
        const ade = document.createElement('script')
        ade.setAttribute('async', 'true')
        ade.setAttribute('src', 'https://www.googletagmanager.com/gtag/js')
        document.body.appendChild(ade)
        // Google Tag Manager
        const spt = document.createElement('script')
        spt.innerHTML =
            "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n" +
            "    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n" +
            "  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n" +
            "  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n" +
            "})(window,document,'script','dataLayer','GTM-KG9BH86');"
        document.body.appendChild(spt)
        // Google Tag Manager (noscript)
        const nos = document.createElement('noscript')
        nos.innerHTML =
            '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KG9BH86" height="0" width="0" ' +
            'style="display:none;visibility:hidden"></iframe>'
        document.body.appendChild(nos)

        if (!window.dataLayer) window.dataLayer = []
        this.gtag('js', new Date())
    },
    gtag() {
        if (!window.dataLayer) window.dataLayer = []
        window.dataLayer.push(arguments)
    },
    emit(eventName, type = ['ga'], parameter = {}) {
        switch (type) {
            case 'ga':
                this.gtag('event', eventName, Object.assign({}, parameter, { send_to: gaId }))
                break
            case 'ga2':
                this.gtag('event', eventName, Object.assign({}, parameter, { send_to: gaId2 }))
                break
        }
    },
    init(str) {
        switch (str) {
            case 'ga':
                this.gtag('config', gaId)
                break
            case 'ga2':
                this.gtag('config', gaId2)
                break
        }
    },
}
